import './SectionCard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SECTION_ICON_STYLE } from './sectionIconStyle';

/**
 * Panel générique de l'app : carte arrondie avec header blanc,
 * pastille d'icône grise et action optionnelle à droite.
 */
// subtitle: optional one-line description under the title (normal case, muted)
// iconStyle: optional { background, color } replacing the neutral gray pastille
const SectionCard = ({ title, subtitle, icon, iconStyle, action, className = '', children }) => (
  <div className={`app-section-card ${className}`.trim()}>
    {title && (
      <div className="app-section-card__title">
        <span className="app-section-card__title-main">
          {icon && (
            <span className="app-section-card__icon" style={iconStyle || SECTION_ICON_STYLE}>
              <FontAwesomeIcon icon={icon} />
            </span>
          )}
          {subtitle ? (
            <span className="app-section-card__heading">
              {title}
              <span className="app-section-card__subtitle">{subtitle}</span>
            </span>
          ) : title}
        </span>
        {action && <span className="app-section-card__action">{action}</span>}
      </div>
    )}
    {children}
  </div>
);

export default SectionCard;
